import store from 'redux-store/store';

import { Store } from 'types';

const GlobalStore: Store = store;

export const isOmbededThumbnailApiEnabled = (): undefined | boolean => (
  GlobalStore.getState()?.runtimeConfig?.config?.ombededThumbnailApiEnabled
);
